/**
 * Short how-to copy for authenticated client account pages.
 */
export const CLIENT_PAGE_GUIDES = {
  account: {
    title: 'Your account',
    steps: [
      'Review your profile details and keep contact info current.',
      'Open My Bookings for events, invoices, and vendor messages.',
      'Use Settings to manage password, notifications, and privacy.',
    ],
  },
  bookings: {
    title: 'Managing your bookings',
    steps: [
      'Filter by status or date to find an event quickly.',
      'Open a booking for details, invoices, and next steps.',
      'Message the vendor from the booking when you need changes.',
    ],
  },
  bookingDetail: {
    title: 'This booking',
    steps: [
      'Confirm date, location, package, and payment status.',
      'Download invoices when available.',
      'Request date changes or leave a review after the event.',
    ],
  },
  favorites: {
    title: 'Your favorites',
    steps: [
      'Save vendors you like while browsing.',
      'Open a profile to compare services and availability.',
      'Book from the vendor page when you are ready.',
    ],
  },
  notifications: {
    title: 'Notifications',
    steps: [
      'See booking updates, invoices, and platform alerts here.',
      'Mark items read after you act on them.',
      'Adjust email/push preferences in Settings.',
    ],
  },
  reviews: {
    title: 'Your reviews',
    steps: [
      'Leave honest feedback after completed events.',
      'Edit or update a review if something changes.',
      'Helpful reviews help other clients choose vendors.',
    ],
  },
  help: {
    title: 'Help & support',
    steps: [
      'Browse FAQs for common booking and payment questions.',
      'Contact support if you need help with a specific booking.',
      'Include booking IDs when you reach out for faster help.',
    ],
  },
  settings: {
    title: 'Account settings',
    steps: [
      'Update your name and phone, then change your password if needed.',
      'Enable two-factor authentication for stronger login security.',
      'Account deletion is permanent — contact support if unsure.',
    ],
  },
  messages: {
    title: 'Site messages',
    steps: [
      'Review conversations with vendors and support.',
      'Reply promptly so your booking stays on track.',
      'For urgent booking issues, open the booking detail page too.',
    ],
  },
  billing: {
    title: 'Billing',
    steps: [
      'Card details are not saved on vendaList — Stripe handles each payment.',
      'Pay deposits and invoices from the booking flow when prompted.',
      'Find receipts and payment history under My Bookings.',
    ],
  },
  transactions: {
    title: 'Transaction history',
    steps: [
      'See payments tied to your bookings.',
      'Filter or search when reconciling a charge.',
      'Open the related booking for invoices and status.',
    ],
  },
};
